export default {
  wrapper: {
    position: 'relative',
    maxWidth: '530px',

    '@media screen and (max-width: 600px)': {
      alignItems: 'center',
      width: '90%',
    },
  },
  form: {
    width: '100%',
  },
  container: {
    padding: '35px',
    background: '#fff',
    borderRadius: '4px',

    '@media screen and (max-width: 600px)': {
      padding: '44px 15px 15px',
    },
  },
  formHeading: {
    marginBottom: '40px',
    fontSize: '32px',
    lineHeight: '37px',
    fontWeight: 'bold',
    textAlign: 'center',

    '@media screen and (max-width: 600px)': {
      marginBottom: '20px',
      fontSize: '24px',
      lineHeight: '28px',
      paddingRight: '36px',
      paddingLeft: '36px',
    },
  },
  heading: {
    marginBottom: '20px',
    fontSize: '32px',
    lineHeight: '37px',
    fontWeight: 'bold',
    textAlign: 'center',

    '@media screen and (max-width: 600px)': {
      marginBottom: '10px',
      fontSize: '24px',
      lineHeight: '28px',
    },
  },
  description: {
    maxWidth: '360px',
    padding: '5px',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 'normal',
    textAlign: 'center',
    color: '#171A1C',
  },
};
